import { Component, OnInit, OnDestroy } from '@angular/core';
import { transition, trigger, stagger, animate, style, query } from '@angular/animations';
import { BackgroundService } from '../shared/services/background.service';

@Component({
  selector: 'app-index-loggedin',
  templateUrl: './index-loggedin.component.html',
  styleUrls: ['./index-loggedin.component.css'],
  animations: [
    trigger('stagger', [
      transition(':enter', [
        query('index-page-button', [
          style({ transform: 'translateY(-30%)', opacity: 0 }),
          stagger(75, [animate('0.2s', style({ transform: 'translateY(0)', opacity: 1 }))])
        ])
      ])
    ])
  ]
})
export class IndexLoggedinComponent implements OnInit, OnDestroy {
  public visible: boolean = false;

  constructor(private header: BackgroundService) {}

  ngOnInit() {
    this.header.setValue({});
    setTimeout(() => (this.visible = true), 0);
  }

  ngOnDestroy() {
    this.visible = false;
  }
}
